import { TICKET_EMAIL_STATE_LABELS, type TicketEmailState } from '@easyhelp/shared';
import Chip from '@mui/material/Chip';

/** Esiti di consegna che chiedono attenzione: l'utente potrebbe non aver letto la risposta. */
const DELIVERY_WARNINGS: readonly TicketEmailState[] = ['rimbalzata', 'reclamo', 'fallita'];

/** Stato di consegna di un'email a chi ha segnalato: risposta (#5) o conferma di ricezione (#117). */
export function DeliveryChip({ delivery }: { delivery: TicketEmailState }) {
  const warning = DELIVERY_WARNINGS.includes(delivery);
  return (
    <Chip
      size="small"
      variant="outlined"
      color={warning ? 'warning' : 'default'}
      label={TICKET_EMAIL_STATE_LABELS[delivery]}
      // Su bianco anche dentro la bolla dell'operatore (#121); `warning.main` è sotto 4.5:1, il testo è `warning.dark`.
      sx={{ bgcolor: 'common.white', ...(warning && { color: 'warning.dark' }) }}
    />
  );
}
